import classes from "./TableLoadingSpinner.module.css";

const TableLoadingSpinner = () => {
  return (
    <div className={classes.spinnerBackdrop}>
      <h2>لطفا منتظر بمانید</h2>
      <h3>درحال انجام عملیات ...</h3>
      <div className={classes.spinnerContainer}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default TableLoadingSpinner;
